// API configuration
// Priority: runtime config (window.__ENV__) -> build-time env -> localhost fallback
const getEnvVar = (key, fallback) => {
  // Check runtime config first (injected at container startup)
  if (window.__ENV__ && window.__ENV__[key] && !window.__ENV__[key].startsWith('__')) {
    return window.__ENV__[key];
  }
  // Fall back to build-time env vars
  if (process.env[key]) {
    return process.env[key];
  }
  // Default fallback for local development
  return fallback;
};

const API_CONFIG = {
  // Base API URL - dynamically set based on environment
  // Fallback order: runtime config -> build-time env -> localhost (development default)
  BASE_URL: getEnvVar('REACT_APP_BASE_URL'), // this is for backend api
  FRONTEND_URL: getEnvVar('REACT_APP_FRONTEND_URL'), // this is for frontend api  

  
  // Auth endpoints
  AUTH: {
    TOKEN: "/public-api/auth/token",
    REFRESH: "/public-api/auth/refresh",
    OAUTH: "/public-api/auth",
    GOOGLE: "/public-api/auth/google",
    REGISTER: "/public-api/auth/register",
    VERIFY_OTP: "/public-api/auth/verify-otp",
    RESEND_OTP: "/public-api/auth/resend-otp",
    FORGOT_PASSWORD: "/public-api/auth/forgot-password",
    RESET_PASSWORD: "/public-api/auth/reset-password",
    LOGOUT: "/public-api/auth/logout",
    PROMPTS: "/public-api/auth/prompts",

  },
  
  // User endpoints
  USER: {
    ME: "/backend-api/me",
  },
  
  // Conversation endpoints
  CONVERSATIONS: {
    HISTORY: "/backend-api/conversations/history",
    CHAT: "/backend-api/conversations/chat",
    GET_MESSAGES: "/backend-api/conversations/messages",
    SEND_MESSAGE: "/backend-api/conversations/message/send",
    CREATE: "/backend-api/conversations",
    DELETE: "/backend-api/conversations/deletechat",
    DELETE_ALL: "/backend-api/conversations/deleteallchats",
    GET_CHAT: "/backend-api/conversations/getchat",
    UPDATE_TITLE: "/backend-api/conversations/update-title",
    GRAPH: "/backend-api/conversations/graph",
    IMAGE: "/backend-api/conversations/image",
    CUSTOM_CHAT: "/public-api/customchat", // Public endpoint for free trial users
    PIN: "/backend-api/conversations/pinnedChat",
    ARCHIVE: "/backend-api/conversations/archiveChat",
    ARCHIVE_CHATS: "/backend-api/conversations/archive_chats",
    SHARE: "/backend-api/conversations/share", // Public endpoint for shared conversations
    FORK_SHARED: "/backend-api/conversations/share", // Endpoint for forking shared conversations
  },
  
  // Audio endpoints
  AUDIO: {
    STREAM: "/backend-api/conversations/audio"
  }
};

export default API_CONFIG;